import React from "react";
import PropTypes from "prop-types";

const SubtasksBodyTemplate = ({ children }) => {
  return <div className="object_subtasks">{children}</div>;
};

SubtasksBodyTemplate.propTypes = {
  children: PropTypes.any,
};

SubtasksBodyTemplate.displayName = "SubtasksBodyTemplate";

export default SubtasksBodyTemplate;
